export default class Produto {
  constructor(
    id_produto = null,
    descricao = '',
    id_unidade = null,
    unidade = '',
    preco_original = 0,
    preco_bruto = 0,
    subtotal_bruto = 0,
    subtotal = 0,
    qtde_produto = 1,
    qtde_unidade = 1,
    desconto = 0,
    perc_desconto = 0,
    id_tabela_preco = null,
    unidades_saida = [],
    observacoes = ''
  ) {
    this.id_produto = id_produto;
    this.descricao = descricao;
    this.id_unidade = id_unidade;
    this.unidade = unidade;
    this.preco_original = preco_original;
    this.preco_bruto = preco_bruto;
    this.subtotal_bruto = subtotal_bruto;
    this.subtotal = subtotal;
    this.qtde_produto = qtde_produto;
    this.qtde_unidade = qtde_unidade;
    this.desconto = desconto;
    this.perc_desconto = perc_desconto;
    this.id_tabela_preco = id_tabela_preco;
    this.unidades_saida = unidades_saida;
    this.observacoes = observacoes;
  }
}